import { AxiosResponse } from "axios";
import { QUERY_CLIENT } from "..";
import { PropertyKey } from "../model/property";
import { QueryKeys } from "./base/react-query";
import { getAxiosInstance } from "./api-utils";

const PROPERTY_KEYS = "/property-keys";

export async function getPropertyKeys(objectType?: string): Promise<PropertyKey[]> {
    const response: AxiosResponse<PropertyKey[]> = await getAxiosInstance().get(PROPERTY_KEYS, {
        params: objectType ? { objectType } : undefined,
    });
    return response.data;
}

export async function getPropertyKey(id: number): Promise<PropertyKey> {
    const response: AxiosResponse<PropertyKey> = await getAxiosInstance().get(`${PROPERTY_KEYS}/${id}`);
    return response.data;
}

export async function savePropertyKey(model: { object: PropertyKey, initialObject: PropertyKey }) {
    const response = await getAxiosInstance().patch(PROPERTY_KEYS, model.object);
    QUERY_CLIENT.invalidateQueries(QueryKeys.propertyKeys);
    return response.data;
}

export async function createPropertyKeyAndGetId(key: PropertyKey): Promise<number> {
    const response: AxiosResponse<PropertyKey> = await getAxiosInstance().put(PROPERTY_KEYS, key);
    QUERY_CLIENT.invalidateQueries(QueryKeys.propertyKeys);
    return response.data.id;
}

export async function createPropertyKey(key: Omit<PropertyKey, 'id'>): Promise<PropertyKey> {
    const response: AxiosResponse<PropertyKey> = await getAxiosInstance().put(PROPERTY_KEYS, key);
    QUERY_CLIENT.invalidateQueries(QueryKeys.propertyKeys);
    return response.data;
}

export async function deletePropertyKey(key: PropertyKey) {
    await getAxiosInstance().delete(`${PROPERTY_KEYS}/${key.id}`);
    QUERY_CLIENT.invalidateQueries(QueryKeys.propertyKeys);
}
